// extracted by mini-css-extract-plugin
export var productImage = "_na-1";
export var viewLink = "_na-2";
export var wishlistItem = "_na-0";